<div class="modal-overlay" *ngIf="isVisible">
  <div class="modal-content">
    <div class="modal-header">
      <h2>{{ title }}</h2>
    </div>
    
    <div class="modal-body">
      <p>{{ message }}</p>
    </div>
    
    <div class="modal-footer">
      <button class="cancel-button" (click)="cancel()">{{ cancelButtonText }}</button>
      <button class="ok-button" (click)="accept()">{{ acceptButtonText }}</button>
    </div>
  </div>
</div>